module.exports = "/img/item-4.ec2e9d41.png";